const localStorageKeys = {
  IMPERSONATION_LOCAL_STORAGE_KEY: 'impersonatedCompanySlug',
};

export default localStorageKeys;
